import React from 'react';
import styled from 'styled-components';

const CardMini = styled.div`
  display: flex;
  width: 160px;
  flex-direction: column;
`;

const Title = styled.div`
  color: var(--gray-gray-300, #707070);
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

const Text = styled.div`
  color: var(--gray-gray-400, #505050);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
`;

const CardHeader = ({ title, detail }) => (
  <>
    <CardMini>
      <Title>{title}</Title>
      <Text>{detail}</Text>
    </CardMini>
  </>
);

export default CardHeader;
